import React, { Fragment } from "react";
import ReactMinimalPieChart from "react-minimal-pie-chart";

/**
 * A simple indicator for displaying a time value nicely.
 * @param value Time in seconds (number).
 * @param color Color of the filled part.
 */
const TimeIndicator = ({ value = 0, color = "#31aca6", style = {}, showTitle = true }) => {
  const { humanDuration, normalizedValue, maxValue } = getHumanDuration(value);
  const textVisibility = showTitle ? "visible" : "hidden";
  const valueY = showTitle ? 60 : 50;

  return (
    <ReactMinimalPieChart
      style={style}
      data={[
        { color: color, key: 1, value: normalizedValue }
      ]}
      {...defaultPieChartProps}
      totalValue={maxValue}
      label={({ color, data, style, key, y, dataIndex, ...props }) => (
        <Fragment key={"timeLabel"}>
          {showTitle && (
            <text
              y={35}
              visibility={textVisibility}
              style={{ fontFamily: "sans-serif", fontSize: "14px" }}
              fill={color}
              dominantBaseline="middle"
              {...props}
            >
              Tiempo
            </text>
          )}
          <text
            y={valueY}
            style={style}
            fill={color}
            dominantBaseline="middle"
            {...props}
          >
            {humanDuration}
          </text>
        </Fragment>
      )}
    />
  );
};

function getHumanDuration(minutes) {
  let humanDuration = "";
  let normalizedValue = 0;
  let maxValue = 0;

  if (minutes < 60) {
    humanDuration = `${Math.round(minutes)}m`;
    normalizedValue = Math.round(minutes);
    maxValue = 60;
  } else if (minutes < 60 * 24) {
    humanDuration = `${Math.round(minutes / 60)}h`;
    normalizedValue = Math.round(minutes / 60);
    maxValue = 24;
  } else if (minutes < 60 * 24 * 99) {
    humanDuration = `${Math.round(minutes / (60 * 24))}d`;
    normalizedValue = Math.round(minutes / (60 * 24));
    maxValue = 99;
  } else {
    humanDuration = `+99d`;
    normalizedValue = 99;
    maxValue = 99;
  }

  return { humanDuration, normalizedValue, maxValue };
}
// Default styles for the PieChart
const defaultPieChartProps = {
  animate: false,
  animationDuration: 500,
  animationEasing: "ease-out",
  cx: 50,
  cy: 50,
  labelPosition: 0,
  labelStyle: { fontFamily: "sans-serif", fontSize: "25px" },
  background: "#E5E5E5",
  lengthAngle: 360,
  lineWidth: 10,
  paddingAngle: 0,
  radius: 50,
  ratio: 1,
  rounded: false,
  startAngle: -90
};

export default TimeIndicator;